// Ukrainian plural agreement. Three forms, picked by the last digit — except the teens (11–14),
// which always take the many-form regardless of what they end in.
//
//   plural(1,  forms) → "конфігурація"   (one)
//   plural(3,  forms) → "конфігурації"   (few, 2–4)
//   plural(12, forms) → "конфігурацій"   (many — a teen, even though it ends in 2)
export default function plural(count, [one, few, many]) {
  const mod100 = Math.abs(count) % 100;
  if (mod100 >= 11 && mod100 <= 14) return many;

  const mod10 = mod100 % 10;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
}
